import React, { Component , Fragment} from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

import Box from '../Layout/Box'
import AttachedFilesBox from '../Shared/AttachedFilesBox'
import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'

import ModalAddFile from '../Shared/ModalAddFile'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'
import Comentarios from '../Shared/Comentarios'

import ModalAddServicio from './ModalAddServicio'


import { isAllowedToViewComponent } from '../../utils/helpers';


import {
    getSolicitud,
    updateInputs,
    addFile,
    removeFiles,
    displayModalAddServicio,
    removeSolicitudServicioItem,
    enviarComentario,
    editarComentario,
    eliminarComentario
} from '../../actions/solicitudservicio'


import {
    showModalSelector,
    selectFromSelector,
} from '../../actions/common'

class General extends Component {


    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/auxiliares', fn)
    }

    modificarSolicitud = (path, value, id) => {
        this.props.updateInputs(path, value, id)
        this.props.updateInputs('addModificacion', true)
    }

	render() {

        const { id, solicitudservicio, enums, user, comentario } = this.props

        const esResponsableCompras = solicitudservicio.getIn(['responsable_compras', 'id']) == user.get('id')
        const esSuperusuario = user.get('es_superusuario')
        const estado = solicitudservicio.get('estado')
        const readOnly = (!esResponsableCompras && !esSuperusuario) || (estado > 1);
        //const readOnly = true

        if (!id) return null

        const actionsSectionDetallesServicios = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" onClick={ e => this.props.displayModalAddServicio(true, 'Agregar Item', 'create') } title="Adicionar servicio" disabled={ readOnly || (solicitudservicio.get('estado') != 1 && solicitudservicio.get('estado') != 2) }/>,
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={e => this.props.removeSolicitudServicioItem()} title="Eliminar servicio" danger disabled={ solicitudservicio.get('servicios') && !solicitudservicio.get('servicios').filter(x => x.get('selected')).count() } />
        ]

        const disabled_comment = (estado === 0 || estado === 7);

		return (
            <div>

                <BoxSection title="Información básica">

                    <div className="row">

                        {
                            isAllowedToViewComponent('administrador', solicitudservicio.get('solicitante')) && solicitudservicio.get('tipo') != 5 && solicitudservicio.get('estado') != 0 && solicitudservicio.get('estado') != 7 ? (

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Solicitante</label>
                                        <SelectorInput value={ solicitudservicio.getIn(['solicitante', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.solicitante`) } onReset={ () => this.props.updateInputs(`solicitud.solicitante`, null) } />
                                    </div>
                                </div>

                            ):(
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Solicitante</label>
                                        <input type="text" value={ solicitudservicio.getIn(['solicitante', 'fullname']) || '' } className="form-control input-sm" disabled/>
                                    </div>
                                </div>
                            )
                        }

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>
                                <input type="text" value={ solicitudservicio.getIn(['solicitante', 'email']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input type="text" value={ solicitudservicio.getIn(['solicitante', 'extension']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Area</label>
                                <input type="text" value={ solicitudservicio.getIn(['solicitante', 'area', 'nombre']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>
                        {
                            solicitudservicio.get('documento_origen_id') && <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">Orden/Contrato</label>
                                    <input type="text" value={enums.documentos.tipos[solicitudservicio.getIn(['documento_origen', 'tipo'])].PREFIJO + solicitudservicio.getIn(['documento_origen', 'consecutivo']) || ''} className="form-control input-sm" disabled />
                                </div>
                            </div>
                        }
                    </div>


                    <div className="row">

                        {
                            isAllowedToViewComponent('administrador', solicitudservicio.get('responsable_compras')) && solicitudservicio.get('tipo') != 5 && solicitudservicio.get('estado') != 0 && solicitudservicio.get('estado') != 7 ? (
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Responsable de compras</label>
                                        <SelectorInput value={ solicitudservicio.getIn(['responsable_compras', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.responsable_compras`) } onReset={ () => this.props.updateInputs(`solicitud.responsable_compras`, null) } />
                                    </div>
                                </div>
                            ):(
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Responsable de compras</label>
                                        <input className="form-control input-sm" type="text" value={ solicitudservicio.getIn(['responsable_compras', 'fullname']) || '' } disabled/>
                                    </div>
                                </div>
                            )
                        }

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>
                                <input className="form-control input-sm" value={ solicitudservicio.getIn(['responsable_compras', 'email']) || '' } disabled />
                            </div>
                        </div>

                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input className="form-control input-sm" type="text" value={ solicitudservicio.getIn(['responsable_compras', 'extension']) || '' }  disabled/>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Fecha de solicitud</label>
                                <input className="form-control input-sm" value={ moment(solicitudservicio.get('created_at')).format('DD/MM/YYYY')  || ''  } disabled />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">No. Solicitud</label>
                                <input className="form-control input-sm" value={ solicitudservicio.get('id') || '' } disabled />
                            </div>
                        </div>

                    </div>

                </BoxSection>


                <BoxSection title="Información del servicio">


                    <div className="row">

                        <div className="col-md-10">
                            <div className="form-group">
                                <label className="control-label">Proyecto/Evento/Actividad</label>
                                <input type="text" value={ solicitudservicio.get('proyecto_evento') || '' } className="form-control input-sm" onChange={ (e) => this.modificarSolicitud('solicitud.proyecto_evento', e.target.value, id) } disabled={ readOnly }/>
                            </div>
                        </div>



                        {
                            readOnly ? (
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label className="control-label">Fecha de entrega</label>
                                        <input type="text" value={ moment(solicitudservicio.get('fecha_requerido')).format('DD/MM/YYYY') || '' } className="form-control input-sm" disabled/>
                                    </div>
                                </div>
                            ):(
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label className="control-label">Fecha de entrega</label>
                                        <input type="date" value={ moment(solicitudservicio.get('fecha_requerido')).format('YYYY-MM-DD') || '' } className="form-control input-sm" onChange={ (e) => this.modificarSolicitud('solicitud.fecha_requerido', e.target.value, id) }/>
                                    </div>
                                </div>
                            )

                        }

                    </div>



                    <div className="row">

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Responsable gestión recibo</label>
                                <input type="text" value={ solicitudservicio.getIn(['responsables_recibo', 0, 'usuario', 'fullname']) || '' } className="form-control input-sm" disabled />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Area</label>
                                <input type="text" value={ solicitudservicio.getIn(['responsables_recibo', 0, 'usuario', 'area', 'nombre']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input type="text" value={ solicitudservicio.getIn(['responsables_recibo',0, 'usuario', 'extension']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Responsable gestión ingreso</label>
                                <input type="text" value={ solicitudservicio.getIn(['responsables_ingreso',0, 'usuario', 'fullname']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Area</label>
                                <input type="text" value={ solicitudservicio.getIn(['responsables_ingreso', 0, 'usuario', 'area', 'nombre']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input type="text" value={ solicitudservicio.getIn(['responsables_ingreso', 0, 'usuario', 'extension']) || '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                    </div>


                </BoxSection>

                <div className="separator"></div>

                <BoxSection title="Detalles servicios" actions={ actionsSectionDetallesServicios }>

                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                        <thead>
                            <tr>
                                <th style={{ width: '20px' }}></th>
                                <th style={{ width: '5%' }}>No.</th>
                                <th style={{ width: '50%' }}>Descripción del servicio</th>
                                <th style={{ width: '10%' }}>Cantidad</th>
                                <th style={{ width: '35%' }}>Centro de costo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (solicitudservicio.get('servicios').count() > 0) ?
                                    solicitudservicio.get('servicios').map((x, n) => {
                                        return (
                                            <tr key={ x.get('id') ? x.get('id') : x.get('guid') } className={ x.get('selected') ? 'info' : '' }>
                                                <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') ? x.get('selected') : false } onChange={e => this.props.updateInputs(`solicitud.servicios.${n}.selected`, e.target.checked, x.get('id'))} disabled={ readOnly || n == 0 || (x.get('cotizaciones') && x.get('cotizaciones').count() > 0) }/></td>
                                                <td className={ `${ readOnly ? '' : 'LinkToEdit' }`}  style={{ textAlign: 'right' }} onClick={ () => readOnly ? null : this.props.displayModalAddServicio(true, 'Modificación de items', 'edit', n) }>{ n + 1 }</td>
                                                <td>{ x.get('descripcion') }</td>
                                                <td>{ x.get('cantidad') }</td>
                                                <td>
                                                {
                                                    x.get('cencos').map(c => {
                                                        return (
                                                            <span key={ c.get('id') ? c.get('id') : c.get('guid') } className="label-cenco-dist" title={ c.get('descripcion') }>{ c.get('codigo') } - <strong>{ numeral(c.getIn(['pivot','porcentaje']) / 100).format('0%') }</strong></span>
                                                        )
                                                    })
                                                }
                                                </td>
                                            </tr>
                                        )
                                    })
                                :
                                    <tr>
                                        <td colSpan={ 5 } style={{ textAlign: 'center' }}>Para crear los servicios haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </BoxSection>

                <div className="separator"></div>

                <BoxSection title="Observaciones">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <textarea type="text" className="form-control input-sm" rows={4} value={ solicitudservicio.get('observaciones') } disabled />
                            </div>
                        </div>
                    </div>
                </BoxSection>

                <div className="separator"></div>

                <Comentarios
                    foros = { solicitudservicio.get('foros') }
                    comentario = { this.props.comentario }
                    updateInputs = { this.props.updateInputs }
                    disabled_comment = { disabled_comment }
                    enviarComentario = { this.props.enviarComentario }
                    editarComentario = { this.props.editarComentario }
                    eliminarComentario = { this.props.eliminarComentario }
                />

                <div className="separator"></div>

                <AttachedFilesBox
                    files={ solicitudservicio.get('adjuntos') }
                    displayModalAddFile = { this.props.displayModalAddFile }
                    removeFiles = { this.props.removeFiles }
                    updateInputs = { this.props.updateInputs }
                    toggleSelectAllSolicitudServicioFiles = { this.props.toggleSelectAllSolicitudServicioFiles }
                    obj={ solicitudservicio }
                    check={ 'solicitud' }
                    root={ 'solicitud' }
                />

                <ModalAddFile
                    action={ () => this.props.addFile(`/files/${id}`, [() => this.props.getSolicitud(id)]) }
                />

                <ModalAddServicio />

                <ModalSelectorFromList />



            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudservicio.get('id'),
        solicitudservicio: state.solicitudservicio.get('solicitud'),
        enums: state.common.get('enums').toJS(),
        user: state.common.get('user'),
        comentario: state.solicitudservicio.get('comentario'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)),
        addFile: (url, actions) => dispatch(addFile(url, actions)),
        removeFiles: () => dispatch(removeFiles()),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        displayModalAddServicio: (show, title, mode, index) => dispatch(displayModalAddServicio(show, title, mode, index)),
        removeSolicitudServicioItem: () => dispatch(removeSolicitudServicioItem()),
        enviarComentario: () => dispatch(enviarComentario()),
        editarComentario: (id) => dispatch(editarComentario(id)),
        eliminarComentario: (id) => dispatch(eliminarComentario(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(General)



// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/General.jsx